import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Flex, { FlexColumn } from 'core/components/Flex';
import Text from 'core/components/Text';
import Button from 'core/components/Button';
import AlertSeverityBars from 'app/views/alerting/components/AlertSeverityBars';
import { formatDateTime } from 'core/util/dateUtils';

@observer
class AlertSeverityHistory extends Component {
  state = {
    expanded: false
  };

  handleToggleExpanded = () => {
    this.setState((prevState) => ({ expanded: !prevState.expanded }));
  };

  render() {
    const { severityHistory = [], minEntries = 1, small = false, maxEntries } = this.props;
    const { expanded } = this.state;

    if (!Array.isArray(severityHistory) || severityHistory.length <= minEntries) {
      return null;
    }

    // Default maxEntries to the higher of 10 or minEntries
    let effectiveMaxEntries = maxEntries ?? Math.max(10, minEntries);
    const hiddenEntries = severityHistory.length - effectiveMaxEntries;

    // If we're only hiding 1 entry, just show it instead of displaying a button
    if (hiddenEntries === 1) {
      effectiveMaxEntries += 1;
    }

    const hasMoreEntries = severityHistory.length > effectiveMaxEntries;
    const displayedHistory =
      expanded || !hasMoreEntries ? severityHistory : severityHistory.slice(-effectiveMaxEntries);

    return (
      <FlexColumn>
        {displayedHistory.map((_, idx) => {
          const { severity, start_time } = displayedHistory[displayedHistory.length - 1 - idx];

          return (
            <Flex
              key={start_time}
              justifyContent="space-between"
              gap={1}
              py={small ? '3px' : '4px'}
              alignItems="center"
            >
              <Flex gap={1} alignItems="center">
                <AlertSeverityBars showLabel small={small} severity={severity} disabled={idx !== 0} />
              </Flex>
              <Text as="div" small={small} muted>
                {formatDateTime(start_time)}
              </Text>
            </Flex>
          );
        })}
        {hasMoreEntries && !expanded && (
          <Flex pt={small ? '3px' : '4px'} justifyContent="center">
            <Button minimal small width="100%" onClick={this.handleToggleExpanded}>
              Show {hiddenEntries} More
            </Button>
          </Flex>
        )}
      </FlexColumn>
    );
  }
}

export default AlertSeverityHistory;
